import { TemplateControl } from '../request-result-modal.types';

export class ControlValueTranslator {

  static hasSemicolonSeparatedValues(control: TemplateControl): boolean {
    const values_en = control.values_en as string || '';
    const values_ru = control.values_ru as string || '';
    const values_uz = control.values_uz as string || '';

    return values_en.includes(';') || values_ru.includes(';') || values_uz.includes(';');
  }


  static translateDropdownValue(
    control: TemplateControl,
    resultValue: string,
    targetLang: string
  ): string | null {
    const values_en = (control.values_en as string || '').split(';').map(v => v.trim());
    const values_ru = (control.values_ru as string || '').split(';').map(v => v.trim());
    const values_uz = (control.values_uz as string || '').split(';').map(v => v.trim());

    const trimmedResult = resultValue.trim();
    let foundIndex = -1;

    // Check in English
    foundIndex = values_en.findIndex(v => v.toLowerCase() === trimmedResult.toLowerCase());

    // Check in Russian if not found
    if (foundIndex === -1) {
      foundIndex = values_ru.findIndex(v => v.toLowerCase() === trimmedResult.toLowerCase());
    }

    // Check in Uzbek if not found
    if (foundIndex === -1) {
      foundIndex = values_uz.findIndex(v => v.toLowerCase() === trimmedResult.toLowerCase());
    }

    // If index found, return the value in the target language
    if (foundIndex !== -1) {
      const targetValuesField = `values_${targetLang}` as keyof TemplateControl;
      const targetValues = (control[targetValuesField] as string || '').split(';').map(v => v.trim());

      if (foundIndex < targetValues.length) {
        return targetValues[foundIndex];
      }
    }

    // If not found, return the original value
    return resultValue;
  }

  static getTranslatedLabel(control: TemplateControl, lang: string): string {
    const labelField = `label_${lang}` as keyof TemplateControl;
    return (control[labelField] || control.label_en || '') as string;
  }

  static getValueWithFallback(control: TemplateControl, lang: string): string {
    const valuesField = `values_${lang}` as keyof TemplateControl;
    let value = (control[valuesField] as string) || '';

    // Fallback to other languages if current language value is empty
    if (!value) {
      value = (control.values_en as string) ||
              (control.values_ru as string) ||
              (control.values_uz as string) || '';
    }

    return value;
  }
}

